import {
  AbsoluteCenter,
  Box,
  Center,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Form, FormikProvider, useFormik } from "formik";
import axios, { AxiosError } from "axios";
import * as Yup from "yup";
import {
  CustomCard,
  CustomFormErrorMessage,
  CustomModal,
  CustomModalActionPrimaryButton,
  PrimaryButton,
  StatusBox,
} from "../../components/custom";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

interface IApiResponse {
  status?: boolean;
  message?: string;
  errorCode?: string;
}

function AccountLinkingForm() {
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [status, setStatus] = useState<"" | "success" | "error">("");
  const [responseMsg, setResponseMsg] = useState("");

  // const navigate = useNavigate();

  // const history = useHistory();

  const location = window.location.search;

  const searchParams = new URLSearchParams(location);
  const tokenFromParams = searchParams.get("token");

  const initialValues = {
    token: tokenFromParams,
  };

  const validationSchema = Yup.object().shape({
    token: Yup.string()
      .max(200, "Token cannot exceed 200 characters")
      .required("Token is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);

        const { data } = await axios.post<IApiResponse>(
          `${process.env.REACT_APP_API_BASE_URL}/link-accounts/complete`,
          {
            token: values.token,
          }
        );

        setStatus("success");
        setResponseMsg(
          data.message ?? "Your account has been linked successfully"
        );
      } catch (err) {
        const error = err as AxiosError<IApiResponse>;

        setStatus("error");
        setResponseMsg(
          error.response?.data?.message ?? "An error occurred, try again"
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  // });

  const { errors, touched, values, getFieldProps, handleSubmit } = formik;

  console.log("values: ", values);

  if (status === "error") {
    return (
      <CustomModal isOpen={status === "error"} onClose={() => setStatus("")}>
        <StatusBox variant="error" title="Failed to link account">
          {responseMsg}
        </StatusBox>

        <CustomModalActionPrimaryButton onClick={() => setStatus("")}>
          Try Again
        </CustomModalActionPrimaryButton>
      </CustomModal>
    );
  }

  if (status === "success") {
    return (
      <CustomModal isOpen={status === "success"} onClose={() => setStatus("")}>
        <StatusBox variant="success" title="Account Linked Successfully">
          {responseMsg}
        </StatusBox>
      </CustomModal>
    );
  }

  return (
    <AbsoluteCenter w={{ base: "100%", md: "initial" }} axis="horizontal">
      <Center py={{ base: 10, md: "80px" }} mx={2}>
        <CustomCard
          minW={{ base: "100%", lg: "400px", xl: "588px" }}
          maxW="588px"
        >
          <Heading
            as="h1"
            fontWeight="400"
            fontSize="1.5rem"
            lineHeight="133%"
            mb={2}
          >
            Complete Account Linking
          </Heading>
          <Text color="gray.300">Enter your token</Text>

          <Box mt={8}>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack spacing={8}>
                  <FormControl
                    id="token"
                    isInvalid={Boolean(touched.token && errors.token)}
                  >
                    <FormLabel>Token</FormLabel>
                    <Input
                      placeholder="Enter the token sent to your email"
                      {...getFieldProps("token")}
                      // isReadOnly
                      // disabled
                    />
                    <CustomFormErrorMessage>
                      {touched.token && errors.token}
                    </CustomFormErrorMessage>
                  </FormControl>
                </Stack>

                <Box mt={10}>
                  <PrimaryButton type="submit" w="full" isLoading={isLoading}>
                    Continue
                  </PrimaryButton>
                </Box>
              </Form>
            </FormikProvider>
          </Box>
        </CustomCard>
      </Center>
    </AbsoluteCenter>
  );
}

export default AccountLinkingForm;
